import React from 'react';
import {Control} from 'react-hook-form';
import cn from 'classnames';

import CloseInput from 'shared/ui/icons/CloseInput';
import SearchIcon from 'shared/ui/icons/SearchIcon';

import Input, {InputProps} from './Input';
import {getInputClassName, useInputState} from './inputState';

import styles from './Input.module.scss';

export interface IInputSearchProps extends InputProps {
    control: Control<any>;
    name: string,
    validate?: boolean;
    iconStyle?: string;
    iconStyleClose?: string;
    isMonitor?: boolean;
    disabled?: boolean
    onClear?: () => void;
    onSearch?: () => void;
}

const InputSearch: React.FC<IInputSearchProps> = ({
    control,
    iconStyle,
    iconStyleClose,
    isMonitor = false,
    className,
    validate = false,
    disabled,
    defaultValue,
    onClear,
    onSearch,
    ...rest
}) => {
    const {field, state} = useInputState({control, name: rest.name, defaultValue, validate});

    const handleClearClick = () => {
        if (onClear) {
            onClear();
        } else {
            field.onChange('');
        }
    };

    const handleSearchClick = () => {
        if (onSearch) {
            onSearch();
        }
    };

    const hasValue = Boolean(field.value && field.value.trim());

    return (
        <div>
            {!isMonitor && (
                <div className={cn(styles.icon, iconStyle)}>
                    <SearchIcon/>
                </div>
            )}
            <Input
                {...rest}
                type="text"
                className={cn(
                    getInputClassName(styles, state),
                    className,
                )}
                disabled={disabled}
            />
            {hasValue && isMonitor && (
                <div>
                    <span
                        onClick={handleClearClick}
                        className={iconStyleClose}
                    >
                        <CloseInput/>
                    </span>
                    <span className={styles.line}>|</span>
                    <span
                        onClick={handleSearchClick}
                        className={iconStyle}
                    >
                        <SearchIcon/>
                    </span>
                </div>
            )}
        </div>
    );
};

export default InputSearch;